import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-slide',
  templateUrl: './slide.page.html',
  styleUrls: ['./slide.page.scss'],
})
export class SlidePage implements OnInit {
  id:any = 0;
  token = '';
  slide:any = {id:'', header: '', text: '', image: ''};

  constructor(public activedRoute:ActivatedRoute, public http:HttpClient, public toastCtrl:ToastController, public alertCtrl:AlertController, public navCtrl:NavController, public modalController:ModalController) {
    this.id = this.activedRoute.snapshot.paramMap.get('id');
    this.token = localStorage.getItem('token');
    this.getProduct();
  }

  back(){
    this.modalController.dismiss();
    //this.navCtrl.back();
  }

  getProduct(){
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/get_home_slide', {
      id:this.id,
      token: this.token
    }).subscribe(async res => {
      if (res.error_code == 0) {
        this.slide = res.data.slide;
      } else {
        await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Возникла ошибка', buttons: ["OK"] }))).present();
      }
    }, async err => {
      await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Проверьте интернет-соединение', buttons: ["OK"] }))).present();
    })
  }

  ngOnInit() {
  }

}
